import React from "react";
import { string, bool } from "prop-types";

import Anchor from "../Anchor";

import NavigateIcon from "../icons/navigate";

import "./profile-menu-item.m.css";

const ProfileMenuItem = ({ type, label, isActive, isNavigateIcon, href }) => {
  if (type === "outer") {
    return (
      <div styleName="outer-wrapper" className="outer-wrapper">
        <span styleName="title-main">{label}</span>
      </div>
    );
  }

  const contentView = (
    <React.Fragment>
      <span styleName={`${isActive ? "title-active" : "title"} `}>{label}</span>
      {isNavigateIcon ? <NavigateIcon /> : null}
    </React.Fragment>
  );

  return type === "saved_news" ? (
    <Anchor aria-label={label} styleName="inner-wrapper" className="inner-wrapper" href={href} target="_blank">
      {contentView}
    </Anchor>
  ) : (
    <Anchor aria-label={label} styleName="inner-wrapper" className="inner-wrapper" href={href}>
      {contentView}
    </Anchor>
  );
};

ProfileMenuItem.defaultProps = {
  isActive: false,
  isNavigateIcon: false,
  type: "inner",
};

ProfileMenuItem.propTypes = {
  label: string.isRequired,
  href: string,
  isActive: bool,
  isNavigateIcon: bool,
  type: string,
};

export default ProfileMenuItem;
